import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskInspectionFodIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fill='currentColor'
                d='M1 0h1.5v24H1V0zM21.5 0H23v24h-1.5V0zM12.6 20.92h-1.2V24h1.2v-3.08zM8.8 20.92H10V24H8.8v-3.08zM7.5 20.92H6.3V24h1.2v-3.08zM3.8 20.92H5V24H3.8v-3.08zM20.2 20.92H19V24h1.2v-3.08zM16.5 20.92h1.2V24h-1.2v-3.08zM15.2 20.92H14V24h1.2v-3.08zM6.3 7.5h1.2v3.08H6.3V7.5zM5 7.5H3.8v3.08H5V7.5zM19 7.5h1.2v3.08H19V7.5zM17.7 7.5h-1.2v3.08h1.2V7.5zM6.3 0h1.2v3.08H6.3V0zM17.7 0h-1.2v3.08h1.2V0zM11.4.045h1.2v3.08h-1.2V.045zM12.6 5h-1.2v3.08h1.2V5z'
            />
            <Path
                fill='currentColor'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15 12.765c0-.522-.073-.979-.218-1.37a2.601 2.601 0 00-1.05-1.343c-.482-.326-1.064-.49-1.746-.49-.645 0-1.204.15-1.677.448a2.6 2.6 0 00-1.036 1.245C9.09 11.684 9 12.182 9 12.75c0 .69.127 1.268.382 1.735.227.438.54.773.94 1.007.41.233.883.35 1.419.35.673 0 1.204-.197 1.595-.588.018-.019.037-.024.055-.014.018.01.027.028.027.056v1.538c0 .392-.127.713-.382.965-.245.243-.563.364-.954.364-.373 0-.678-.117-.914-.35-.236-.242-.354-.55-.354-.923v-.098a.134.134 0 00-.055-.112.129.129 0 00-.109-.056H9.395a.168.168 0 00-.122.056.153.153 0 00-.041.112v.308c0 .485.118.914.354 1.287.246.373.582.662 1.01.867.436.205.931.308 1.486.308.572 0 1.077-.103 1.513-.308.446-.215.791-.513 1.037-.895.245-.383.368-.825.368-1.329v-4.266zm-1.582-.084c0 .43-.072.793-.218 1.091-.236.466-.636.7-1.2.7-.527 0-.918-.224-1.173-.672-.163-.298-.245-.657-.245-1.077 0-.354.068-.685.204-.993.237-.503.646-.755 1.228-.755.6 0 1.009.257 1.227.77.118.27.177.582.177.936z'
            />
        </>
    ),
})

TaskInspectionFodIcon.displayName = 'TaskInspectionFodIcon'
